import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Fixed, always-on-screen ReBorn badge — vertically centered on the right
 * edge of the viewport, present on every storefront page (rendered once,
 * outside the route tree, so it survives navigation without needing to be
 * repeated per-route the way Header/Footer currently are).
 *
 * Hidden on /admin (a separate app shell with its own layout — a public
 * marketing badge has no business floating over the dashboard) and on
 * /reborn itself (the badge's own destination — showing it there is just
 * noise) and /coming-soon (no site chrome at all on that gate page).
 *
 * The hover message is a plain native browser tooltip (the `title`
 * attribute), not a custom styled one, per spec.
 */
const ReBornFloatingBadge = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  if (pathname.startsWith('/admin') || pathname === '/reborn' || pathname === '/coming-soon') {
    return null;
  }

  return (
    <Link
      to="/reborn"
      title={t('rebornBadge.learnMore')}
      aria-label={t('rebornBadge.learnMore')}
      data-testid="reborn-floating-badge"
      style={{
        position: 'fixed',
        top: '50%',
        right: '18px',
        transform: 'translateY(-50%)',
        zIndex: 60,
        display: 'block',
        lineHeight: 0,
        transition: 'transform 250ms ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-50%) scale(1.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
      }}
    >
      <img
        src="/reborn-logo.png"
        alt={t('rebornBadge.alt')}
        style={{
          width: '92px',
          height: 'auto',
          padding: '8px 10px',
          background: '#FEFCF7',
          border: '1px solid #E5DFD3',
          borderRadius: '14px',
          filter: 'drop-shadow(0 2px 10px rgba(0,0,0,0.22))',
        }}
      />
    </Link>
  );
};

export default ReBornFloatingBadge;
